<script>
// `~/stores/episode-store` lives outside the editor directory tree.
// Studio canvas preview only needs the example shareCount; real
// `navigator.share` round-trips happen on the FanWeb side.
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import DynamicComponentActionElement
  from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";

export default {
  name: "EpisodeShareCountAction",
  elementPanelSettings: {
    displayName: "Share Action",
    displayIcon: "material-symbols:share",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: DynamicComponentActionElement,
  mixins: [EpisodePageElementMixin],
  computed: {
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.shareCount || 0 : "";
    },
  },
  methods: {
    handleClick() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
